import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import SuperAdminAuthContext from "../context/superadmin/SuperAdminAuthContext";

const SuperAdminPublicRoute = () => {
  const { token } = useContext(SuperAdminAuthContext);

  if (token) {
    return <Navigate to="/su/admin/tenants" replace />;
  }

  return <Outlet />;
};

export default SuperAdminPublicRoute;
